import * as React from 'react';
import Rating from '@mui/material/Rating';
import Box from '@mui/material/Box';
// import StarIcon from '@mui/icons-material/Star';
import { FaStar } from 'react-icons/fa';

const labels = {
  0.5: 'Useless',
  1: 'Useless+',
  1.5: 'Poor',
  2: 'Poor+',
  2.5: 'Ok',
  3: 'Ok+',
  3.5: 'Good',
  4: 'Good+',
  4.5: 'Excellent',
  5: 'Excellent+',
};

function getLabelText(value) {
  return `${value} Star${value !== 1 ? 's' : ''}, ${labels[value]}`;
}

export default function RatingHoverFeedback({ value, setValue, style }) {
  //   const [value, setValue] = React.useState(2);
  const [hover, setHover] = React.useState(-1);

  return (
    <Box
      style={style}
      sx={{
        width: 'fit-content',
        maxWidth: '100%',
        display: 'flex',
        alignItems: 'center',
      }}
    >
      <Rating
        sx={{
          fontSize: { xs: '44px', sm: '52px' },
          gap: { xs: '4px', sm: '8px' },
          '& .MuiRating-icon': { transition: 'transform 150ms ease, color 150ms ease' },
          '& .MuiRating-iconHover': { transform: 'scale(1.15)' },
          '& .MuiRating-iconFilled': { color: '#f59e0b', filter: 'drop-shadow(0 2px 4px rgba(245, 158, 11, 0.3))' },
          '& .MuiRating-iconEmpty': { color: '#cbd5e1' },
        }}
        name="hover-feedback"
        value={value}
        // precision={0.5}
        // getLabelText={getLabelText}
        onChange={(event, newValue) => {
          setValue(newValue);
        }}
        onChangeActive={(event, newHover) => {
          setHover(newHover);
        }}
        // emptyIcon={<FaStar style={{ opacity: 0.55, fontSize: '50px' }} />}
      />
      {/* <div>
        {value !== null && (
          <Box sx={{ ml: 2 }}>{labels[hover !== -1 ? hover : value]}</Box>
        )}
      </div> */}
    </Box>
  );
}
